// src/features/signup/signupSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";
// ?competitor_campaign_id=2&report_type=market intelligence
export const createReport = createAsyncThunk(
  "competitor/createReport",
  async (
    { competitor_campaign_id, report_type, site_ids },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await axiosInstance.post(
        `/admin/generate-competitor-report/appsells?competitor_campaign_id=${competitor_campaign_id}&report_type=${report_type}`,
        { site_ids },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        const res = response;

        return {
          data: res.data,
          headers: {
            contentType: response.headers["content-type"],
            contentLength: response.headers["content-length"],
          },
        };
      } else {
        // Handle non-success responses
        throw new Error(
          "Add Competitor failed with status: " + response.status
        );
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const createReportSlice = createSlice({
  name: "createReport",
  initialState: {
    campaign: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    resetStatusCreate: (state) => {
      state.status = "idle";
      state.error = null;
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.campaign = action.payload; // Store only user data
      })
      .addCase(createReport.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStatusCreate } = createReportSlice.actions;

export default createReportSlice.reducer;
